import { Base } from './base-model';
import { Collection } from './collection';

export class Song extends Base {
    name: string
    key: string  // C C# Db D D# Eb E F F# Gb G G# Ab A A# Bb B
    tonality: string // Major minor dorian phrygian Lydian Mixolydian aeolian Other (NOTE: capitalization is important)
    meter: string  // Duple, Triple, Duple/Triple, Swing, Asymmetric, Other
    startingPitch: string
    isSwow: boolean
    url: string
    karaokeUrl: string
    tags: string
    suggestedActivity: string
    otherInfo: string
    tpName: string
    tpUrl: string
    rpName: string
    rpUrl: string
    tsbUrl: string  // url of teacher song book
    time: string

    static defaults(): Song {
        const song = new Song()
        song.uuid = null
        song.name = ''
        song.key = ''
        song.tonality = ''
        song.meter = ''
        song.startingPitch = ''
        song.isSwow = false
        song.url = ''
        song.karaokeUrl = ''
        song.tags = ''
        song.suggestedActivity = ''
        song.otherInfo = ''
        song.tpName = ''
        song.tpUrl = ''
        song.rpName = ''
        song.rpUrl = ''
        song.tsbUrl = ''
        song.time = ''
        return song
    }

    tagsList(): string[] {
        // return this.tags.splitTrim()  // for some reason isn't working for this class????
        return (this.tags || '').split(',').map((value: string) => value.trim()).filter((value: string) => value.length > 0)
    }

    get formattedTonality(): string {
        const firstTonalityChar = this.tonality.substr(0, 1)
        if (firstTonalityChar === firstTonalityChar.toLowerCase()) {
            return this.key.toLowerCase() + ' ' + this.tonality + (this.startingPitch ? ' (' + this.startingPitch + ')' : '')
        } else {
            return this.key + ' ' + this.tonality + (this.startingPitch ? ' (' + this.startingPitch + ')' : '')
        }
    }

    get isMajor(): boolean { return this.tonality && this.tonality.toLowerCase().indexOf('major') >= 0  && this.tonality.toLowerCase().indexOf('minor') < 0 }
    get isNonmajor(): boolean { return this.tonality && !this.isMajor }
    get isDuple(): boolean { return this.meter && this.meter.toLowerCase() === 'duple' }
    get isNonduple(): boolean { return this.meter && !this.isDuple }

    get isHelloSong(): boolean { return this.name.startsWith('Hello') || this.name.startsWith('Hey, Hey, Wha') }
    get isGoodbyeSong(): boolean { return this.name.startsWith('Goodbye') }
    get isDefaultSong(): boolean { return this.name.length === 0 }
    
    get isTonalPatterns(): boolean { 
        return this.name.startsWith('Tonal Patterns') || this.name.includes('TP')
    }
    
    get isRhythmPatterns(): boolean { 
        return this.name.startsWith('Rhythm Patterns') || this.name.includes('RP')
    }

    get isSilentTrack(): boolean {
        const songName: string = this.name.toLowerCase()
        return songName.includes('silent track')
    }

    get isInstrumental(): boolean {
        const songName: string = this.name.toLowerCase()
        return songName.includes('(inst.)') || songName.includes('(inst)') || songName.includes('(instrumental)')
    }

    findCollection(collections: Collection[]): Collection {
        return Song.findCollection(this.uuid, collections)
    }

    static findCollection(songUuid: string, collections: Collection[]): Collection {
        return collections.find((collection: Collection) => {
            if (!collection.songs) {
                return false
            }
            return collection.songs.find((song: Song) => {
                return song.uuid === songUuid
            }) ? true : false   // not as stupid as it looks
        })
    }
}
